import { useMemo } from 'react';
import dayjs from 'dayjs';
import { type MRT_ColumnDef } from 'material-react-table';
import { usersTableParams } from '../../../pages/users/userTableQuery';
import { type UserRow } from '../../../pages/users/useUsersTable';
import { idColumn, booleanColumn } from './tableColumns';
import ServerTable, { type ServerTableProps } from './ServerTable';
import { MANAGED_USER_TYPE_OPTIONS } from '../../../services/userRoles';

export default function UsersTable(props: ServerTableProps<UserRow>) {
  const columns = useMemo<MRT_ColumnDef<UserRow>[]>(() => [
    idColumn<UserRow>(),
    { accessorKey: 'user_type', header: 'User Type', size: 180, filterVariant: 'select',
      filterSelectOptions: MANAGED_USER_TYPE_OPTIONS },
    { accessorKey: 'first_name', header: 'First Name', size: 210, filterFn: 'contains', muiFilterTextFieldProps: { placeholder: 'Contains…' } },
    { accessorKey: 'last_name', header: 'Last Name', size: 210, filterFn: 'contains', muiFilterTextFieldProps: { placeholder: 'Contains…' } },
    { accessorKey: 'email', header: 'Email', size: 290, filterFn: 'contains' },
    ...(['date_joined', 'last_login'] as const).map((field): MRT_ColumnDef<UserRow> => ({
      id: field, header: field === 'date_joined' ? 'Created' : 'Last Login', size: 235,
      accessorFn: row => row[field] ? dayjs(row[field]) : null,
      filterVariant: 'date-range',
      Cell: ({ row }) => row.original[field] ? dayjs(row.original[field]).format('DD MMM YYYY HH:mm:ss') : '—',
    })),
    booleanColumn<UserRow>('is_active', 'Active', 'Active', 'Inactive'),
  ], []);

  return <ServerTable {...props} columns={columns} title="Users" recordLabel="users" createLabel="Create User"
    searchPlaceholder="Search name or email" dateFields={['date_joined', 'last_login']}
    rowTestKey={row => `email-${row.email}`} exportEndpoint="users" exportParams={usersTableParams} />;
}
